import { Measurement } from '../../api';

export enum MeasurementDisplayStatus {
  Hidden,
  Visible,
}

export interface MeasurementViewModel extends Measurement {
  state: MeasurementDisplayStatus;
  deleting: boolean;
  markupIds?: number[];
}

export function mapMeasurement(measurement: Measurement): MeasurementViewModel {
  const viewModel: MeasurementViewModel = {
    ...measurement,
    state: MeasurementDisplayStatus.Hidden,
    deleting: false,
  };
  return viewModel;
}
